<bz-card [padded]="false" class="table-settings-header">
  <div class="layout-row layout-align-start-center padding-10 card-title">
    <span class="flex br-body-2 weight--600">{{ (title() || 'Table Columns') | translate }}</span>
    <span container="body" placement="left" [ngbTooltip]="'Show More' | translate">
      <bz-icon [icon]="isOpen() ? chevronUp : chevronDown"></bz-icon>
    </span>
  </div>

  @if (isOpen()) {
    <bz-divider></bz-divider>
    <div class="layout-row layout-wrap layout-align-start-center columns-container">
      @for (entry of entries(); track entry.key) {
        <div class="flex-50 layout-row padding-left-10">
          <bz-switch *ngxPermissionsOnly="entry.column.permission"
                     appBringozIdGenerator="table-columns-settings-checkbox"
                     size="sm"
                     [checked]="!!entry.column.enabled"
                     (checkedChange)="onToggle(entry.column, $event)">
            <span class="br-body-2">{{ entry.labelKey | translate }}</span>
          </bz-switch>
        </div>
      }
    </div>
  }
</bz-card>
